import React from 'react';

import { IProps } from './types';
import './mobile-email-verify-result-style.scss';

import { Loading } from '@atoms';
import Button from '@src/componentsNew/Buttons/Button';
import Typography from '@src/componentsNew/Typography/Typography';
import MobileCustomHeader from '@src/componentsNew/Header/CustomHeader/MobileCustomHeader';

const MobileEmailVerifyResultPage = ({
  loading,
  isVerified,
  onClickVerifyLaterButton,
  onClickResendEmailButton,
}: IProps) => {
  if (loading) {
    return <Loading />;
  }

  return (
    <div id="mobile-email-verify-result-wrapper">
      <MobileCustomHeader
        type="center"
        isShowBackBtn={true}
        backBtnColor="#212121"
        onBackBtnClick={onClickVerifyLaterButton}
      />

      <div className="email-verify-result-content-wrapper">
        <div className="text-content">
          <Typography variant="h6" component="h4">
            {isVerified ? 'Verification Completed' : 'Verification Failed'}
          </Typography>

          <Typography cName="info-text" variant="body1" component="p">
            {isVerified ? 'Congratulations!' : 'Oops, Something went wrong.\nPlease try verification again.'}
          </Typography>
        </div>

        <div className="btn-wrapper">
          {isVerified ? (
            <Button size="large" cName="verify-complete-btn" variant="contained" onClick={onClickVerifyLaterButton}>
              Go To Home
            </Button>
          ) : (
            <>
              <Button size="medium" cName="verify-later-btn" variant="text" onClick={onClickVerifyLaterButton}>
                Verify later
              </Button>

              <Button size="large" cName="resend-email-btn" variant="contained" onClick={onClickResendEmailButton}>
                Resend Email
              </Button>
            </>
          )}
        </div>
      </div>
    </div>
  );
};

export default MobileEmailVerifyResultPage;
